var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "condition px-2", attrs: { row: "", wrap: "" } },
    [
      _vm.$route.name !== "block_vehicle_details"
        ? _c(
            "v-flex",
            { staticClass: "detail-header", attrs: { xs3: "" } },
            [
              _c("sub-navigation-title-duplicate", {
                attrs: {
                  "is-icon": _vm.CoIsIcon,
                  icon: _vm.coIcon,
                  "load-more-visible": false,
                  title: _vm.coTitle,
                  source: _vm.coSource
                },
                on: { click: _vm.handleClick },
                model: {
                  value: _vm.dtMenu,
                  callback: function($$v) {
                    _vm.dtMenu = $$v
                  },
                  expression: "dtMenu"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.coMenuAuths.edit ||
      _vm.coMenuAuths.delete ||
      _vm.coMenuAuths.scheduleMaintenance
        ? _c(
            "v-flex",
            {
              staticClass: "actions-menu__wrapper",
              attrs: {
                "pb-3": "",
                xs3: "",
                "mt-0": "",
                "pt-0": "",
                "text-xs-right": ""
              }
            },
            [
              _c("crud-menu", {
                key: _vm.coMenuKey,
                attrs: { texts: _vm.coMenuTexts, auths: _vm.coMenuAuths },
                on: {
                  edit: _vm.handleMenuEdit,
                  delete: _vm.handleMenuDelete,
                  scheduleMaintenance: _vm.handleMenuScheduleMaintenance,
                  addDocToEquipment: _vm.handleMenuAddDocToEquipment
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73c72bde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73c72bde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/components/block-detail-header/template.html
// module id = null
// module chunks = 